// extracted by mini-css-extract-plugin
export default {"wrapper":"fog__wrapper__vQBCC"};